export default ({ color, fontSize, typography }) => ({
  searchBar: {
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: '0 auto',
    width: '88%',
  },
  label: {
    marginBottom: 5,
  },
  menuDivider: {
    margin: '0 0 0.5em 0',
    backgroundColor: `${color.borderColor} !important`,
  },
  filterContainer: {
    height: '89%',
    display: 'block',
    position: 'relative',
  },
  linkBtn: {
    borderColor: 'none',
    border: 'none',
    height: '40px!important',
    background: 'none',
    outline: 'none',
    display: 'inline',
    color: color.link,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:hover,&:active': {
      color: color.linkHover,
    },
  },
  button: {
    margin: '10px 10px',
  },
  linkBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 20,
  },
  errorMessage: {
    color: 'red',
    padding: '2px',
  },
  searchFieldContainerClass: {
    marginBottom: '0 !important',
  },
});
